import React from "react";
import { useParams } from "react-router";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  baseRoute,
  CompanyScreensPath,
  orderPaymentScreenPath,
} from "../routes";
import NotFoundScreen from "./NotFoundScreen";
import { useGetCompany } from "../useCases/company";
import {
  isRequestLoading,
  isRequestLoaded,
  getRequestResource,
  isRequestError,
} from "../models/RequestState";
import LoadingScreen from "./LoadingScreen";
import OrderScreen from "./OrderScreen";
import { ModalAvailableRoute } from "./ModalAvailableRoute";

const CompanyScreensNavigator: React.FC = () => {
  const { companySlug } = useParams<{ companySlug: string }>();
  const getCompanyState = useGetCompany(companySlug);

  if (isRequestError(getCompanyState)) {
    return <NotFoundScreen />;
  }
  if (isRequestLoaded(getCompanyState)) {
    const { company } = getRequestResource(getCompanyState);
    if (company == null) {
      return <NotFoundScreen />;
    }
  }

  const isLoading = isRequestLoading(getCompanyState);
  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <Switch>
      <ModalAvailableRoute
        exact={true}
        path={orderPaymentScreenPath.pathDefinition}
      >
        <OrderScreen company={getRequestResource(getCompanyState)?.company} />
      </ModalAvailableRoute>
    </Switch>
  );
};

const Navigator: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route
          exact={true}
          path={baseRoute.pathDefinition}
          component={NotFoundScreen}
        />
        <ModalAvailableRoute path={CompanyScreensPath.pathDefinition}>
          <CompanyScreensNavigator />
        </ModalAvailableRoute>
      </Switch>
    </Router>
  );
};

export default Navigator;
